import './styles.scss';

import React, { useEffect } from 'react';

import moment from 'moment';

import FeedAPI from '../../../api/FeedAPI';
import { useAppProvider } from '../../../context/AppProvider';
import { useTheme } from '../../../context/ThemeProvider';
import showAppError from '../../../shared/error';
import { useAppSelector } from '../../../shared/hooks';
import { IVideoCallsItem, IWebinar } from '../../../types/feedTypes';
import UpcomingWorkshopCard from './UpcomingWorkshopCard/UpcomingWorkshopCard';

const UpcomingWorkshops: React.FC = () => {
  const { colors } = useTheme();

  const { onMeetingJoin, getMeetingJoinStatus, isMeetingHost } =
    useAppProvider();

  const { postState, selected } = useAppSelector((state) => state.activity);
  const userDetails = useAppSelector((state) => state.user);

  const [webinars, setWebinars] = React.useState<IWebinar[]>([]);

  const fetchRecentVideoCalls = async () => {
    try {
      const res = await FeedAPI.getCreatorWebinarsV5({
        status: 'upcoming',
        page: 1,
        limit: 10,
      });
      if (
        res.status === 200 &&
        res.data.result &&
        res.data.result.videocalls?.[0]?.length
      ) {
        const filtertedVideoCalls = (res.data.result?.videocalls?.[0] || [])
          .reduce((acc: IWebinar[], each: IVideoCallsItem) => {
            if (!each.calls) {
              return acc;
            }

            return [...acc, ...each?.calls];
          }, [])
          .filter((videoCall) =>
            moment(videoCall.fromTime).isSameOrAfter(moment(), 'day'),
          );

        // get all the ongoing calls
        let recentVideoCalls = filtertedVideoCalls.filter(
          (videoCall) => videoCall?.status === 'ongoing',
        );

        // get the recent call which is scheduled for today or tomorrow
        // show this only if there are no ongoing calls found
        if (recentVideoCalls?.length === 0) {
          recentVideoCalls = filtertedVideoCalls
            .filter((videoCall) =>
              moment(videoCall.fromTime).isSameOrBefore(
                moment().add(1, 'day'),
                'day',
              ),
            )
            .slice(0, 1);
        }

        setWebinars(recentVideoCalls);
      }
    } catch (error) {
      showAppError(error);
    }
  };

  useEffect(() => {
    if (postState.refreshing) {
      fetchRecentVideoCalls();
    }
  }, [postState.refreshing]);

  useEffect(() => {
    if (selected) {
      fetchRecentVideoCalls();
    }
  }, [selected]);

  return (
    <>
      {webinars.map((webinar) => (
        <UpcomingWorkshopCard
          key={webinar._id}
          webinar={webinar}
          colors={colors}
          userDetails={userDetails}
          onMeetingJoin={onMeetingJoin}
          getMeetingJoinStatus={getMeetingJoinStatus}
          isMeetingHost={isMeetingHost}
        />
      ))}
    </>
  );
};

export default React.memo(UpcomingWorkshops);
